module.exports = __webpack_public_path__ + "img/escaner 1.6f90570e.svg";